import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string().required('email required'),
  username: Yup.string().required('username required'),
  fullname: Yup.string().required('fullname required'),
  password: Yup.string(),
  role_id: Yup.string().uuid().required('role required'),
});
